"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ProductListItem = void 0;
var _icons = require("@ori-ui/icons");
var _constants = require("../../../../constants");
var _useTranslations = require("../../../../hooks/useTranslations");
var _models = require("../../../../models");
var _ListTypeIcon = require("../ListTypeIcon/ListTypeIcon");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ProductListItem = (param)=>{
    let { productListId, name, items } = param;
    const { translations, formatMessage } = (0, _useTranslations.useTranslations)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        href: "".concat(_constants.BASE_PATH, "/product-list/").concat(_models.ProductListType.Personal, "/").concat(productListId),
        alignItems: "flex-start",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ListTypeIcon.ListIcon, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.ItemLabel, {
                primary: name,
                secondary: formatMessage('productNumber', {
                    products: items.length.toString()
                }),
                className: "list-name"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.ArrowIconButton, {
                "aria-label": translations.editList,
                className: "list-button",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.ArrowRightThin, {})
            })
        ]
    });
};
exports.ProductListItem = ProductListItem;
